import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import './App.css';

// --- Components ---
import MemoiresMentionnes from './MemoiresMentionnes';
import MemoiresNonMentionnes from './MemoiresNonMentionnes'; 
import LoginPage from './LoginPage';
import SignUpPage from './SignUpPage'; 
import ThesisDetail from './ThesisDetail'; 
import ThesisDetailNonM from './ThesisDetailNonM';
import AddMemoirePage from './AddMemoire.jsx'; 
import AddMemoirePageN from './AddMemoireNonM.jsx';
import PremiumPage from './PremiumPage.js';
import AdminPremium from './AdminPremium.jsx';
import AddMemoirePremium from './AddMemoirePremium.jsx';
import MemoiresPremium from './MemoiresPremium.jsx';
import ThesisDetailPremium from './ThesisDetailPremium';



// --- Assets ---
import cover1 from './assets/cover1.jpeg';
import cover2 from './assets/cover2.jpeg';
import cover3 from './assets/cover3.jpeg';
import cover4 from './assets/cover4.jpeg';
import cover5 from './assets/cover5.jpeg';
import cover6 from './assets/cover6.jpeg';
import cover7 from './assets/cover7.png';
import cover8 from './assets/cover8.png';
import cover9 from './assets/cover9.png';
import cover10 from './assets/cover10.png';
import cover11 from './assets/cover11.png';
import cover12 from './assets/cover12.png';
import cover13 from './assets/cover13.png';
import cover14 from './assets/cover14.jpeg';
import cover15 from './assets/cover15.png'; 
import cover16 from './assets/cover16.jpeg';
import cover17 from './assets/cover17.png';
import cover18 from './assets/cover18.png';
import cover19 from './assets/cover19.png';
import cover20 from './assets/cover20.png';
import cover21 from './assets/cover21.png';
import cover22 from './assets/cover22.png';
import cover23 from './assets/cover23.png';
import cover24 from './assets/cover24.png';
import cover25 from './assets/cover25.png';
import cover26 from './assets/cover26.jpeg';
import cover27 from './assets/cover27.webp';
import cover28 from './assets/cover28.webp';
import cover29 from './assets/cover29.webp';
import cover30 from './assets/cover30.webp';
import myLogo from './assets/logo.png';
import uniLogo from './assets/logouniv.png'; 
import incubatorLogo from './assets/logoincub.png';
import teclangLogo from './assets/teclang_Logo-removebg-preview.png';

// --- Home Logic Component ---
const HomePage = ({ backgroundImages, currentImageIndex, setCurrentImageIndex, handleNext, handlePrev, getSlideClass, setIsPaused }) => (
  <>
    <section className="welcome-section">
      <div className="features-grid">

        <div className="glass-card feature-card">
      <h3>QU'EST-CE QUE LA PLATEFORME MÉMOFAC ?</h3>
      <p>
        La plateforme MémoFac est un espace numérique dédié à la consultation bibliographique à distance. 
        Elle offre aux étudiants et chercheurs un accès centralisé aux mémoires de fin d'études de l'Université de Boumerdès. 
        Notre mission est de faciliter la recherche académique, d'assurer la visibilité des travaux et de soutenir l'innovation.
      </p>
    </div>

        <div className="glass-card feature-card">
          <h3>NOTRE CONTENU</h3>
          <p>MémoFac est une plateforme numérique dédiée à la collecte documentaire des mémoires de master en littérature et civilisation française, Faculté des Langues et des Lettres Boumerdès. Elle propose un accès structuré aux données bibliographiques, aux axes de recherche, aux problématiques et aux mots-clés. La plateforme met également en évidence les lacunes des travaux existants afin d’orienter et d’améliorer les recherches académiques futures.</p>
        </div>
        
        <div className="glass-card feature-card full-width">
          <h3>PRÉSENTATION DES AUTEURS</h3>
          <p>Les auteurs étudiés sur MémoFac sont des créateurs francophones dont les publications sont récentes, issus de différentes générations et contextes historiques. Notre corpus permet de mettre en perspective l’évolution des courants littéraires, des thématiques et des contextes culturels. La particularité de notre plateforme est qu’elle regroupe plusieurs productions littéraires dont la majorité est algérienne.</p>
        </div>

        <div className="glass-card feature-card full-width">
          <h3>NOS AXES DE RECHERCHE</h3>
          <p>Les axes de recherche de MémoFac servent à structurer et organiser les thématiques abordées dans les mémoires des étudiants soutenus dans le cadre du master Littérature et Civilisations francophones. Ils aident les chercheurs à orienter leur choix de sujet de recherche, à mieux définir leurs problématiques, et à identifier les manques de la recherche afin d’encourager des travaux innovants et pertinents.</p>
        </div>

        <div className="glass-card feature-card full-width">
          <h3>MOTS CLÉS</h3>
          <p>Littératures, Francophonie, Algériens, Romans, Master, Mémoire de fin d’études.</p>
        </div>
      </div>
    </section>

    <header className="hero-section">
      <h2 className="cover-title">Romans 2016-2025</h2>
      <div className="carousel-3d-container" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}>
        <button className="nav-arrow left" onClick={handlePrev}>❮</button>
        <div className="carousel-track">
          {backgroundImages.map((img, index) => (
            <div key={index} className={getSlideClass(index)} style={{ backgroundImage: `url(${img})` }} onClick={() => setCurrentImageIndex(index)}>
              <div className="slide-overlay"></div> 
            </div>
          ))}
        </div>
        <button className="nav-arrow right" onClick={handleNext}>❯</button>
      </div>

      {/* Carousel Dots */}
      <div className="carousel-dots">
        {backgroundImages.map((_, idx) => (
          <span 
            key={idx} 
            className={`dot ${idx === currentImageIndex ? 'active' : ''}`} 
            onClick={() => setCurrentImageIndex(idx)}
          ></span>
        ))}
      </div>
    </header>

    <section className="contact-section">
      <div className="glass-card contact-glass-card">
        <h2>Contactez-nous</h2>
        <form className="contact-form">
          <input type="text" placeholder="Votre Nom" required />
          <input type="email" placeholder="Votre Email" required />
          <textarea placeholder="Votre Message" required></textarea>
          <button type="submit" className="cta-button">Envoyer</button>
        </form>
      </div>
    </section>

    <section className="partners-section">
      <h2>Nos Partenaires</h2>
      <div className="logos-container">
        <div className="partner-card"><img src={incubatorLogo} alt="Incubator" className="partner-logo" /></div>
        <span className="partner-separator">X</span> 
        <div className="partner-card"><img src={uniLogo} alt="University" className="partner-logo" /></div>
      </div>
    </section>

    {/* 1. Collaboration Section */}
  <section className="collaboration-section">
      <h2>En collaboration avec</h2>
      <div className="collaboration-container">
        <img 
          src={require('./assets/Bibiothéque du département de Boumerdes département de français (2).png')} 
          alt="Bibliothèque du département" 
          className="collaboration-banner" 
        />
        
        {/* Section Teclang (Texte + Logo) */}
        <div className="collaboration-extra-logos">
          <h3 className="teclang-title">Laboratoire Teclang :</h3>
          <img src={teclangLogo} alt="Teclang Logo" className="teclang-logo" />
        </div>
        
      </div>
    </section>

    {/* 2. Social Contacts Section */}
    <section className="social-contacts-section">
      <h2>Nos Contacts</h2>
      <div className="social-icons-container">
        <a href="https://www.facebook.com/share/1AykShJLCq/?mibextid=wwXIfr" target="_blank" rel="noreferrer" className="social-icon facebook">
          <i className="fab fa-facebook-f"></i> {/* Use FontAwesome or local images */}
          <span>Facebook</span>
        </a>
        <a href="tel:+213668322663" className="social-icon phone">
          <i className="fas fa-phone"></i>
          <span>Appelez-nous</span>
        </a>
        {/* Simple Button */}
    <button className="social-icon copy-link-btn" onClick={() => { navigator.clipboard.writeText(window.location.href); alert("Lien copié !"); }}>
      <i className="fas fa-link"></i>
      <span>Copier le lien</span>
    </button>
      </div>
    </section>
  </>
);

// --- Protected Route ---
const ProtectedRoute = ({ children }) => {
  const isAdmin = localStorage.getItem("role") === "admin";
  return isAdmin ? children : <Navigate to="/login" replace />;
};

// --- Main App Logic ---
function AppContent() {
  const [isLoading, setIsLoading] = useState(true);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const backgroundImages = [cover1, cover2, cover3, cover4, cover5, cover6, cover7, cover8, cover9, cover10, cover10, cover11, cover12, cover13, cover14, cover15, cover16, cover17, cover18, cover19, cover20, cover21, cover22, cover23, cover24, cover25, cover26, cover27, cover28, cover29, cover30];

  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isPaused) return; 
    const interval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev === backgroundImages.length - 1 ? 0 : prev + 1));
    }, 3000); 
    return () => clearInterval(interval);
  }, [isPaused, backgroundImages.length]);

  const handleNext = () => setCurrentImageIndex((p) => (p === backgroundImages.length - 1 ? 0 : p + 1));
  const handlePrev = () => setCurrentImageIndex((p) => (p === 0 ? backgroundImages.length - 1 : p - 1));

  const getSlideClass = (index) => {
    if (index === currentImageIndex) return 'slide active';
    if (index === currentImageIndex - 1 || (currentImageIndex === 0 && index === backgroundImages.length - 1)) return 'slide prev';
    if (index === currentImageIndex + 1 || (currentImageIndex === backgroundImages.length - 1 && index === 0)) return 'slide next';
    return 'slide hidden';
  };



  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <div className="loading-text">MémoFac</div>
      </div>
    );
  }

  const isFullScreenPage = location.pathname === '/login' || location.pathname === '/signup';
  const handleLogout = () => {
  // Supprime toutes les données de session
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("username");
  
  // Optionnel : Forcer un rechargement ou rediriger
  navigate("/login");
  window.location.reload(); // Astuce simple pour rafraîchir l'état de l'app
};

  return (
    <div className="app-container">
      {!isFullScreenPage && (
<nav className="navbar">
  <div className="nav-left">
    <img src={myLogo} alt="Logo" className="nav-logo" onClick={() => navigate('/')} />
  </div>
  
  <span className="nav-title-center clickable-title" onClick={() => navigate('/')}>MémoFac</span>
  
  <div className="nav-right nav-controls-group"> 
    
    {/* On vérifie si un utilisateur est connecté via le token */}
    {localStorage.getItem("token") ? (
      <>
        {/* Affiche le nom de l'utilisateur à côté du bouton */}
        <span className="nav-username" style={{ marginRight: '10px', fontSize: '14px', fontWeight: '500' }}>
          {localStorage.getItem("username")}
        </span>
        <button className="login-button logout-btn" onClick={handleLogout}>
          Déconnexion
        </button>
      </>
    ) : (
      <button className="login-button" onClick={() => navigate('/login')}>
        Se connecter
      </button>
    )}

    <div className="menu-container"> 
      <button className="hamburger"> ☰ </button>
      <div className="dropdown-menu"> 
        <ul>
          <li><span className="menu-link" onClick={() => navigate('/memoires-mentionnes')}>Mémoires mentionnés</span></li>
          <li><span className="menu-link" onClick={() => navigate('/memoires-non-mentionnes')}>Mémoires non-mentionnés</span></li>
          <li> <span className="menu-link premium-link" onClick={() => navigate('/premium')}>Premium</span></li>
        </ul>
      </div>
    </div>
  </div>
</nav>
      )}

      <div className="page-transition">
        <Routes>
          <Route path="/" element={
            <HomePage 
              backgroundImages={backgroundImages} 
              currentImageIndex={currentImageIndex}
              setCurrentImageIndex={setCurrentImageIndex}
              handleNext={handleNext} handlePrev={handlePrev}
              getSlideClass={getSlideClass} setIsPaused={setIsPaused}
            />
          } />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/memoires-mentionnes" element={<MemoiresMentionnes onThesisClick={(t) => navigate('/thesis-detail', { state: { thesis: t } })} />} />
          <Route path="/memoires-non-mentionnes" element={<MemoiresNonMentionnes onThesisClick={(t) => navigate('/thesis-detail-non-m', { state: { thesis: t } })} />}/>
          <Route path="/thesis-detail" element={<ThesisDetailWrapper />} />
          <Route path="/thesis-detail-non-m" element={<ThesisDetailNonMWrapper />} />
          <Route path="/premium" element={<PremiumPage />} />
          <Route path="/memoire-premium" element={<MemoiresPremium onThesisClick={(t) => navigate('/thesis-detail-premium', { state: { thesis: t } })} />} />
           <Route path="/thesis-detail-premium" element={<ThesisDetailPremiumWrapper />} /> 
          {/* 🆕 Ta nouvelle route sécurisée */}
          <Route path="/admin-premium" element={
            <ProtectedRoute>
              <AdminPremium />
            </ProtectedRoute>
          } />

            <Route path="/addmemoire-premium" element={
            <ProtectedRoute>
              <AddMemoirePremium/>
            </ProtectedRoute>
          } />
          
          <Route path="/add-memoire" element={
            <ProtectedRoute>
              <AddMemoirePage />
            </ProtectedRoute>
          } />
          <Route path="/add-memoireNM" element={
            <ProtectedRoute>
              <AddMemoirePageN />
            </ProtectedRoute>
          } />
        </Routes>
      </div>
      
      {!isFullScreenPage && (
        <footer className="footer">
          <p>Elablorée par: Abbas Naila </p>
          <p>Sous direction: Pr. Lila Medjahed | Pr. Farid BenRamdane </p>
          <p>&copy; 2025 MémoFac. Conçu pour l'Université de Boumerdès.</p>
        </footer>
      )}
    </div>
  );
}

function ThesisDetailWrapper() {
  const location = useLocation();
  const navigate = useNavigate();
  const thesis = location.state?.thesis;
  return thesis ? <ThesisDetail thesis={thesis} onBack={() => navigate('/memoires-mentionnes')} /> : null;
}

// Ce wrapper permet de récupérer les données envoyées via navigate()
function ThesisDetailNonMWrapper() {
  const location = useLocation();
  const navigate = useNavigate();
  const thesis = location.state?.thesis;
  
  // Si on a bien une thèse, on affiche le nouveau composant, sinon on ne montre rien
  return thesis ? (
    <ThesisDetailNonM 
      thesis={thesis} 
      onBack={() => navigate('/memoires-non-mentionnes')} 
    />
  ) : null;
}

// Wrapper pour les mémoires Premium
function ThesisDetailPremiumWrapper() {
  const location = useLocation();
  const navigate = useNavigate();
  const thesis = location.state?.thesis;
  
  return thesis ? (
    <ThesisDetailPremium 
      thesis={thesis} 
      onBack={() => navigate('/memoire-premium')} 
    />
  ) : null;
}
export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}